export default "__VITE_ASSET__BJMLhrUT__"